module.exports = __webpack_public_path__ + "assets/img/imgbig_cj.ad8f311e.jpg";